import React from 'react';

export default function DashboardPageShell({ children }) {
  return (
    <div className="space-y-6 pb-12">
      {children}
    </div>
  );
}
